import React from "react";
import { Container } from "react-bootstrap";
import CardItem from "../CardItem";
import lozad from "lozad";

const observer = lozad();
observer.observe();

function Certificates() {
  return (
    <>
      <style>
        {`
          @media only screen and (max-width: 1024px) {
            .cards__item {
              margin-bottom: 2rem;
              width: 100%;
              margin-left: -13px;
            }
          }
        `}
      </style>

      {/* row */}
      <ul className="cards__items">

        <CardItem
          class="lozad"
          src="images/certificates/h2c.png"
          text="Completion Certificate"
          label="Certificate"
        />

         <CardItem
          class="lozad"
          src="images/certificates/gv4.png"
          text="Explore Generative AI with the Vertex Gemini API"
          label="Badge"
        />

         <CardItem
          class="lozad"
          src="images/certificates/gv5.png"
          text="Inspect Rich Documents with Gemini Multimodality and Multimodal RAG"
          label="Badge"
        /> 

        <CardItem
          class="lozad"
          src="images/certificates/gv1.png"
          text="Prompt Design in Vertex AI"
          label="Badge"
        />

        <CardItem
          class="lozad"
          src="images/certificates/gv2.png"
          text="Develop Gen AI Apps with Gemini and Streamlit"
          label="Badge"
        />

        <CardItem
          class="lozad"
          src="images/certificates/gv3.png"
          text="Build Real World AI Applications with Gemini and Imagen"
          label="Badge"
        />
      </ul>

      <ul className="cards__items">
        <CardItem
          class="lozad"
          src="images/certificates/c1.jpg"
          text="RTU- Poornima Hackathon 2021"
          label="Hackathon"
        />

        <CardItem
          class="lozad"
          src="images/certificates/celebal.png"
          text="Celebal Technologies Cloud Developer Internship"
          label="Internship"
        />

        <CardItem
          class="lozad"
          src="images/certificates/co.jpg"
          text="Responsive Web Design in Adobe XD"
          label="Course"
        />
      </ul>

      {/* ---- row 2 ---- */}

      <ul className="cards__items">
        <CardItem
          class="lozad"
          src="images/certificates/cognizant.png"
          text="Agile Methodology Virtual Experience Program Certificate"
          label="Course"
        />
        <CardItem
          class="lozad"
          src="images/certificates/startup.jpg"
          text="RTU TEQIP-III SPONSORED STARTUP INNOVATION CONTEST"
          label="Participation"
        />
        <CardItem
          class="lozad"
          src="images/certificates/accenture.png"
          text="Developer Virtual Experience Program Certificate"
          label="Course"
        />
      </ul>

      <ul className="cards__items">
        <CardItem
          class="lozad"
          src="images/certificates/tata.png"
          text="Data Visualisation: Empowering Business with Effective Insights Certificate"
          label="Course"
        />
        <CardItem
          class="lozad"
          src="images/certificates/c4.jpg"
          text="Identifying Intellectual Property component at the early stage of Innovation, Session Certificate"
          label="Session"
        />
        <CardItem
          class="lozad"
          src="images/certificates/c5.jpg"
          text='An Online Quiz Contest, to Commemorate 133rd Birth anniversary of "Great Indian Mathematician "Srinivasa Ramanujan" on NATIONAL MATHEMATICS DAY'
          label="Quiz"
        />
      </ul>

      {/* ---- row 3 ---- */}

      <ul className="cards__items">
        <CardItem
          class="lozad"
          src="images/certificates/c3.jpg"
          text='One day Beginner workshop on "BASIC WEB DESIGNING"'
          label="Workshop"
        />
        <CardItem
          class="lozad"
          src="images/certificates/c7.jpg"
          text='Online Workshop on "ART AND STRATEGIES TO WRITE A BASIC REVIEW PAPER'
          label="Workshop"
        />
        <CardItem
          class="lozad"
          src="images/certificates/Yoga.jpg"
          text='"International Yoga Day" held on Monday, June 21, 2021'
          label="Participation"
        />

        <CardItem
          class="lozad"
          src="images/certificates/c6.jpg"
          text='10-days TEQIP-III Sponsored Online Workshop on Remedial Classes "Engineering Mathematics-I'
          label="Quiz"
        />
      </ul>
    </>
  );
}

export default Certificates;
